<template>
    <div class="technology technology_reveal">
        <h1 class="title technology_title_reveal">Front-End</h1>
        <div class="container technology_languages_reveal">
            <div class="technology-box">
                <img src="../../../assets/img/languages/html.svg" class="language" alt="HTML5" title="HTML5" />
            </div>
            <div class="technology-box">
                <img src="../../../assets/img/languages/css.svg" class="language" alt="CSS3" title="CSS3" />
            </div>
            <div class="technology-box">
                <img src="../../../assets/img/languages/js.svg" class="language" alt="JavaScript" title="JavaScript" />
            </div>
            <div class="technology-box">
                <img src="../../../assets/img/languages/jquery.svg" class="language" alt="jQuery" title="jQuery" />
            </div>
            <div class="technology-box">
                <img src="../../../assets/img/languages/vuejs.svg" class="language" alt="Vue.js" title="Vue.js" />
            </div>
            <div class="technology-box">
                <img src="../../../assets/img/languages/sass.svg" class="language" alt="Sass" title="Sass" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TechnologyFrontEnd',
};
</script>
